module.exports = __webpack_public_path__ + "default-profile-icon.svg";